import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
/*App imports*/
import { HelpersService } from '../../services/tools/helpers.service';
import { ReportesConcentradosService } from '../../services/reportes/reportes-concentrados.service';
import { CreditosColocadosComponent } from './components/creditos-colocados/creditos-colocados.component';
import { ConcentradosPagosComponent } from './components/concentrados-pagos/concentrados-pagos.component';
import { ReportsHelperService } from '../../services/tools/reports-helpers.service';
import { SucursalesService } from '../../services/sucursales.service';

@Component({
    selector: 'reporte-concentrados',
    templateUrl: './reporte-concentrados.component.html'
  })

export class ReporteConcentradosComponent implements OnInit {
  @ViewChild('reporteCreditos') reporteCreditos: CreditosColocadosComponent;
  @ViewChild('reportePagos') reportePagos: ConcentradosPagosComponent;

  public errors: any = {};
  public fechaInicio: string = null;
  public fechaFin: string = null;
  public reportData: any = {};
  public activeView: string = 'general';
  public title: string = '';
  public isLoading: boolean = true;

  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";

  constructor(
    private helperService: HelpersService,
    private reportesService: ReportesConcentradosService,
    public helper: ReportsHelperService,
    public location: Location,
    private sucursalesService: SucursalesService
  ){
  }

  public ngOnInit() {
    this.getSucursales();
  }

  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          this.isLoading = false;
          this.setupDefaultState(); 
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  sucursalChanged(sucursal){
    if(sucursal){
      this.sucursal = sucursal;
      this.updateReporte();
    }
  }

  private setupDefaultState() {
    let defaultDates = this.helper.getDefaultDates();
        
        this.fechaInicio = defaultDates.fechaInicio;
        this.fechaFin = defaultDates.fechaFin;

    this.updateReporte();
  }

  public updateReporte(){
    this.isLoading = true;
    let filters = {
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin,
      sucursal : this.sucursal.id
    }
    switch(this.activeView){
      case 'general':
        this.title = 'INFORMACIÓN GENERAL';
        this.updateReporteGeneral(filters);
        break;
      case 'creditos-colocados':
        this.title = 'CRÉDITOS COLOCADOS';
        this.reporteCreditos.update(filters);
        break;
      case 'pagos':
        this.title = 'PAGOS REALIZADOS';
        this.reportePagos.update(filters);
        break;
    }
  }

  private updateReporteGeneral(filters){

    this.reportesService.general(filters).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content && jsonResult.content.length > 0){
          this.reportData = jsonResult.content[0];
          console.log("ReportData: ",this.reportData);
        }
        
        this.onAfterLoad();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public returnVistaAnterior(){
    switch(this.activeView){
      case 'general':
        this.location.back();
        break;
      default:
          this.activeView = 'general';
          this.updateReporte();
        break;
    }
  }

  public showCreditosColocados(){
    this.activeView = 'creditos-colocados';
    this.updateReporte();
  }

  public showPagos(){
    this.activeView = 'pagos';
    this.updateReporte();
  }

  public print(){
    //Imprimir pantalla
    window.print();
  }

  public onAfterLoad(){
    this.isLoading = false;
  }

  public descargar() {

    let filters = {
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin,
      sucursal : this.sucursal.id
    }

    switch(this.activeView){
      case 'general':
        this.descargarGeneral(filters);
        break;
      case 'creditos-colocados':
          this.reporteCreditos.descargar(filters);
        break;
      case 'pagos':
        this.reportePagos.descargar(filters);
        break;
    }
  }

  private descargarGeneral(filters: any){
    this.reportesService.general(filters, true).subscribe(
        (response)=>
        {
          const fileUrl = window.URL.createObjectURL(response.blob());
          //Muestra el archivo en una nueva ventana
          window.open(fileUrl);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/reportes/concentrados/reporte-concentrados.component.ts